// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"storyblokMedia_wrapper__EV9wf"};